export class Model_Crm_List
    {      
  
         public ListName : string;
        public ListId : number;
        public IsActive : boolean;
        
    }       